import { render, staticRenderFns } from "./page-quotation-yes.vue?vue&type=template&id=6cb368e5"
import script from "./page-quotation-yes.js?vue&type=script&lang=js&external"
export * from "./page-quotation-yes.js?vue&type=script&lang=js&external"
import style0 from "./page-quotation-yes.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports